export enum AccountingType {
  FISCAL = 'FISCAL',
  NON_FISCAL = 'NON_FISCAL',
  INTERNAL = 'INTERNAL'
}
